import React, { useState } from "react";
import logo from "../../assets/images/logo.png";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useTranslation } from "../../contexts/TranslationContext";
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';

import blackGoogle from "../../assets/images/black-google.png"
import blackApple from "../../assets/images/black-apple.png"

const Footer = () => {
  const { t, isRTL } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Create FormData object for form-data submission
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('phone', formData.phone);
      formDataToSend.append('subject', formData.subject);
      formDataToSend.append('message', formData.message);

      const response = await fetch(`${process.env.REACT_APP_API_URL}/contactUs`, {
        method: 'POST',
        body: formDataToSend,
      });

      const result = await response.json();

      if (result.status) {
        // Show success message with SweetAlert
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: result.message || 'Thank you for contacting us! We will get back to you soon.',
          confirmButtonColor: '#03b463',
          confirmButtonText: 'OK'
        });
        
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      } else {
        // Show error message with SweetAlert
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: result.message || 'Failed to send message. Please try again.',
          confirmButtonColor: '#dc3545',
          confirmButtonText: 'OK'
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      // Show network error with SweetAlert
      Swal.fire({
        icon: 'error',
        title: 'Network Error!',
        text: 'Please check your connection and try again.',
        confirmButtonColor: '#dc3545',
        confirmButtonText: 'OK'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="footer" id="contact" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="container pt-5">
        <div className="row">
          <div className="col-md-3 col-sm-5 footer-left">
            <img alt="Logo" src={logo} className="footer-logo mb-3" />
            <p>
            {t("footer.description")}
            </p>
            <div className="d-flex gap-3 download-btns mt-5">
              <img src={blackApple} alt="" />
              <img src={blackGoogle} alt="" />
            </div>
          </div>
          <div className="col-md-3 col-12 col-sm-2 footer-middle">
            <h4 className="fw-semibold">{t("footer.topLinks")}</h4>
            <div className="">
              <nav className="nav footer-nav flex-column py-3 me-3">
                <a href="#home" className="nav-link">
                  {t("footer.home")}
                </a>
                <a className="nav-link" href="#about">
                  {t("footer.aboutUs")}
                </a>
                <a className="nav-link" href="#services">
                  {t("footer.services")}
                </a>
                <a className="nav-link" href="#features">
                  {t("footer.features")}
                </a>

             
                <a className="nav-link" href="#downloadApp">
                  {t("footer.downloadApp")}
                </a>
                <Link className="nav-link" to="/terms">
                  {t("footer.termsCondition")}
                </Link>
                <Link className="nav-link" to="/privacy">
                  {t("footer.privacyPolicy")}
                </Link>
              </nav>
            </div>
          </div>

          <div className="col-md-6 col-12">
            <div className="contact-form">
              <h2 className="fw-bold mb-2">{t("footer.getInTouch")}</h2>
              <p className="text-muted mb-4">
                {t("footer.helpText")}
              </p>

              <Form onSubmit={handleSubmit}>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Control 
                      type="text" 
                      name="name"
                      placeholder={t("footer.fullName")}
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Control 
                      type="email" 
                      name="email"
                      placeholder={t("footer.email")}
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                </Row>

                <Form.Group className="mt-3">
                  <Form.Control
                    type="text"
                    name="subject"
                    placeholder={t("footer.subject")}
                    value={formData.subject}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mt-3">
                  <Form.Control 
                    as="textarea" 
                    rows={4} 
                    name="message"
                    placeholder={t("footer.message")}
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>

                <Button 
                  type="submit" 
                  className="w-100 mt-4 send-btn btn-base"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : t("footer.send")}
                </Button>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom p-3 mt-3">
        <div class="container">
          <div className="copyright d-flex flex-wrap align-items-center gap-4">
            <span className="copyright-text">
              {t("footer.copyright")} | <span className="contact-email">{t("footer.contactEmail")}</span>
            </span>
            <div className="social-icons d-flex align-items-center gap-3">
              <a href="https://www.instagram.com/lmtkom.ae?igsh=OWU4Z2RiMXo5aWJy&utm_source=qr" target="_blank"
               aria-label="Instagram" ><i className="bi bi-instagram"></i></a>
              <a href="https://wa.me/+971502742386" target="_blank" aria-label="WhatsApp"><i className="bi bi-whatsapp"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
